import { deferTracking, sendGAEvent } from '@noths/polaris-client-google-analytics';

export const trackReviewsImpression = () => {
  deferTracking(() =>
    sendGAEvent({
      event: 'custom_event',
      event_category: 'Product reviews',
      event_action: 'Impression',
      event_label: 'not set',
    }),
  );
};

export const trackRatingSystemInfoClick = () => {
  deferTracking(() =>
    sendGAEvent({
      event_action: 'Product rating system click',
      event_category: 'Product reviews',
      event_label: 'not set',
      event: 'custom_event',
    }),
  );
};

export const trackReviewToggle = () => {
  deferTracking(() =>
    sendGAEvent({
      event_action: 'Expand review click',
      event_category: 'Product reviews',
      event_label: 'not set',
      event: 'custom_event',
    }),
  );
};

export const trackPaginationClick = (page: number) => {
  deferTracking(() =>
    sendGAEvent({
      event_action: 'Pagination click',
      event_category: 'Product reviews',
      event_label: String(page),
      event: 'custom_event',
    }),
  );
};

export const trackNextPageClick = (page: number) => {
  deferTracking(() =>
    sendGAEvent({
      event_action: 'Next page click',
      event_category: 'Product reviews',
      event_label: String(page),
      event: 'custom_event',
    }),
  );
};
